<template>
  <div ref="sidebarRef" class="sidebar sidebar-main sidebar-expand-lg align-self-start"
    :class="{ 'sidebar-mobile-scroll': currentScreenSize === screenSize.MOBILE }">
    <div class="sidebar-content">
      <div class="sidebar-section">
        <div class="sidebar-section-body d-flex justify-content-center">
          <h5 v-if="currentScreenSize !== screenSize.MOBILE"
            class="sidebar-resize-hide flex-grow-1 my-auto cursor-pointer d-flex align-items-center gap-2"
            @click="goHome">
            <i class="ph-house"></i>
            {{ $t('Main_Page') }}
          </h5>

          <div>
            <button type="button"
              class="btn btn-light btn-icon btn-sm rounded-pill border-transparent sidebar-control sidebar-main-resize d-none d-lg-inline-flex">
              <i class="ph-arrows-left-right"></i>
            </button>

            <button type="button"
              class="btn btn-light btn-icon btn-sm rounded-pill border-transparent sidebar-mobile-main-toggle d-lg-none">
              <i class="ph-x"></i>
            </button>
          </div>
        </div>
      </div>

      <div class="sidebar-section">
        <ul class="nav nav-sidebar" data-nav-type="accordion">
          <li v-for="(item, index) in sideBarMappedElements" :key="index" :class="{
            'nav-item': (item.SubItems === null || item.SubItems.length === 0),
            'nav-item nav-item-submenu': !(item.SubItems === null || item.SubItems.length === 0),
            'c-seperator-top': item.HasTopSeperator
          }">
            <SideBarItemComp v-if="item.RouterName === '/home'" :sideBarItem="item" />
            <SideBarItemComp v-else-if="permissionService.hasPermissionForParent(item)" :sideBarItem="item" />
          </li>
        </ul>
      </div>
    </div>
  </div>

</template>
<script>
import { useScreenSize, ScreenSize } from '@/composables/useScreenSize';
import SideBarService from "@/services/sideBarService/sideBarService.js";
import SideBarItemComp from "@/components/layoutComponents/SideBar/SideBarItemComp.vue";
import { SideBarItemModel } from "@/models/sideBarModel/sideBarModel";
import { useAuthAppStore } from "@/store/stores/authStore.js"

export default {
  data() {
    return {
      sideBarMappedElements: null,
      searchQuery: "",
      useAuthAppStore: useAuthAppStore(),
      currentScreenSize: useScreenSize().currentScreenSize,
      screenSize: ScreenSize,
    };
  },
  inject: ["permissionService"],
  components: {
    SideBarItemComp,
  },
  created() {
    var sideBarService = new SideBarService();
    this.sideBarMappedElements = sideBarService.getSideBarElements();
  },
  mounted() {
    document.addEventListener("click", this.handleOutsideClick);
  },
  unmounted() {
    document.removeEventListener("click", this.handleOutsideClick);
  },
  methods: {
    handleOutsideClick(event) {
      const sidebar = this.$refs.sidebarRef;
      const toggleButton = document.querySelector('.sidebar-mobile-main-toggle');
      const isOpenSideBar = document.querySelector('.sidebar-mobile-expanded');

      // Eğer sidebar görünürse ve dışına tıklanmışsa
      if (
        sidebar &&
        !sidebar.contains(event.target) &&
        // Birden fazla toggle butonu olabileceği için en yakınını kontrol et
        !(event.target && event.target.closest && event.target.closest('.sidebar-mobile-main-toggle')) &&
        isOpenSideBar !== null &&
        this.currentScreenSize == ScreenSize.MOBILE// sadece mobil görünümde uygula (d-lg-none breakpoint)
      ) {

        this.closeSidebar();
      }
    },
    closeSidebar() {
      // Sidebar kapama işlemi (örneğin class çıkarma)
      const expandedEl = document.querySelector(".sidebar-mobile-expanded");
      if (expandedEl) {
        expandedEl.classList.remove('sidebar-mobile-expanded');
      }
      // document.body.classList.remove('sidebar-mobile-expanded');
    },
    hasPermissionForParent(item) {
      let userPerms = this.useAuthAppStore?.getParsedToken?.perms;

      // return item.SubItems?.some(subItem => {
      //   return userPerms?.map(item => item.split('.')[0]).includes(subItem.PermissionCode?.split('.')[0] || subItem.PermissionCodes[0]?.split('.')[0]);
      // });

      if (!userPerms) return false;

      return item.SubItems?.some(subItem => {
        if (subItem.PermissionCode) {
          return userPerms.includes(subItem.PermissionCode);
        }
        if (subItem.PermissionCodes && subItem.PermissionCodes.length > 0) {
          return subItem.PermissionCodes.some(code => userPerms.includes(code));
        }
        return true; // Eğer yetki kontrolü yoksa true döndür
      });
    },
    goHome() {
      this.$router.push('/home'); // anasayfanın path'i neyse onu yaz
    }
  },

};
</script>
<style>
.c-seperator-top {
  border-top: 1px solid #ddd;
  margin-top: 5px;
  padding-top: 5px;
}

/* Sadece mobilde aktif olacak scroll */
.sidebar-mobile-scroll .sidebar-content {
  max-height: 100vh;
  /* ekran boyu kadar */
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  /* mobilde yumuşak scroll */
}
</style>
